import { render, staticRenderFns } from "./ReportOffBoardingBalances.vue?vue&type=template&id=70aec4fe&v-if=isLoggedIn&"
import script from "./ReportOffBoardingBalances.vue?vue&type=script&lang=js&"
export * from "./ReportOffBoardingBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports